import apiUrl from '../../../constants';
import axios from 'axios';
import VueElementLoading from 'vue-element-loading';
import CryptoJS from 'crypto-js';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import moment from 'moment'

export default {
  name: 'AddDamageByOperation',
  components: {
    VueElementLoading,
    Multiselect,
  },
  data() {
    return {
      awbnumber: '',
      regionName: '',
      hubzonename: '',
      currentHubName: '',
      destinationHubName: '',
      bagCondition: '',
      DEPSbagCondition: '',
      OctroiMRP: '',
      Clientname: '',
      productDescription: '',
      STDreason: '',
      description: '',
      hubOrigin: '',
      Currenthub: '',
      Destinationhub: '',
      lastService: '',
      currentRegion: '',
      editshowtable: false,
      HubZoneId: '',
      newhubList: [],
      vStatusList: [
        { value: "Intact", label: 'Intact' },
        { value: "Torn/Damage", label: 'Torn/Damage' },
        { value: "WithoutSeal", label: 'WithoutSeal' },
      ],
      StatusList: [
        { value: 1, label: 'Liquid Spillage' },
        { value: 2, label: 'Poor Packaging' },
        { value: 3, label: 'Improper Handling' },
        { value: 4, label: 'Accidental Damage' },
        { value: 5, label: 'Fragile Items' },
        { value: 6, label: 'Damage due to Rain' },
        { value: 7, label: 'Natural Calamity' },
        { value: 8, label: 'Pilferage' },
      ],
      hubdroplist: [],
      myStr: '',
      shipmenarr: [],
      imagesarr: [],
      attachment: null,
      displaytable: false,
      fname1: 'wallpaperflare.com_wallpaper-1.jpg',
      imgdata: '',
      showModal: false,
      statuss: '',
      imgData:'',
      isLoading:false,
      isuploadLoading:false,
      FileSelected:''
    };
  },
  mounted() {
   var userTokenEncrypt = window.localStorage.getItem('userToken')
    var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
    var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userid = userdetail[0].email;
  },
  methods: {
    resetForm() {
      this.imagesarr = [];
      this.awbnumber = '';
      this.regionName = '';
      this.hubzonename = '';
      this.currentHubName = '';
      this.destinationHubName = '';
      this.bagCondition = '';
      this.DEPSbagCondition = '';
      this.OctroiMRP = '';
      this.Clientname = '';
      this.productDescription = '';
      this.STDreason = '';
      this.description = '';
      this.hubOrigin = '';
      this.Currenthub = '';
      this.Destinationhub = '';
      this.lastService = '';
      this.currentRegion = '';
      this.isLoading=false;
      this.isuploadLoading=false;
      this.$validator.reset();
      this.errors.clear();
    },

    searchAwbNumber() {
      if (!this.awbnumber) {
        this.$alertify.error("AWB number is required");
        return;
      }
      this.isLoading = true;
      this.input = ({
      	ShippingID: this.awbnumber,
      })
      axios({
        method: 'post',
        url: apiUrl.api_url_hubops + `InvestigationSearchAWb`,
        data: this.input,
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'authkey xB84JJ89Hd25',
        },
      })
      .then((result) => {
        this.isLoading = false;
        this.editshowtable = false;
        if (result.data.ReturnCode === 100) {
          this.shipmenarr = result.data.result;
          this.OctroiMRP = this.shipmenarr.OctroiMRP;
          this.Clientname = this.shipmenarr.ClientName;
          this.productDescription = this.shipmenarr.ProductDesc;
          this.description = this.shipmenarr.Description;
          this.bagCondition = this.shipmenarr.BagCondition;
          this.STDreason = this.shipmenarr.STDReason;
          this.hubzonename = this.shipmenarr.hubzonename;
          this.gethubList();
          this.gethubZoneByHubId(this.shipmenarr.CurrentHubID);
          this.editshowtable = true;
        } else {
          this.$alertify.error(result.data.ReturnMessage);
        }
      })
      .catch((error) => console.error(error));
      this.editshowtable = false;
    },

    gethubList() {
        this.input = ({})
        axios({
          method: 'post',
          url: apiUrl.api_url_hubops + 'getHubdetailsFromFMS',
          data: this.input,
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'authkey xB84JJ89Hd25',
          },
        }).then((result) => {
          if (result.data.ResultCode == 100) {
          const facilities = result.data.ResponseData.facilitiesDetails;
          this.newhubList = facilities.map(hub => ({
            id: hub.facilityId,
            label: hub.facilityName,
          }));
          
          this.newhubList.forEach((hub) => {
            if (hub.id === this.shipmenarr.CurrentHubID) {
              this.currentHubName = hub.label;
            }
            if (hub.id === this.shipmenarr.OriginHubID) {
              this.hubOrigin = hub.label;
            }
            if (hub.id === this.shipmenarr.FinalDestinationID) {
              this.destinationHubName = hub.label;
            }
          });
        }else{
					this.$alertify.error(result.data.ReturnMessage);
			  }
      })
      .catch((error) => console.error(error));
    },

    gethubZoneByHubId(hubID) {
      this.input = ({
        'facilityIds': [hubID]
      });
      axios({
        method: 'post',
        url: apiUrl.api_url_hubops + 'getHubdetailsFromFMS',
        data: this.input,
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'authkey xB84JJ89Hd25',
        },
      })
      .then((result) => {
        if (result.data.ResultCode == 100) {
        this.HubZoneID = result.data.ResponseData.listOfZone[0].zoneId;
        this.hubzonename = result.data.ResponseData.listOfZone[0].zoneName;
      }else{
        this.$alertify.error(result.data.ReturnMessage);
      }
      })
      .catch((error) => console.error(error));
    },

    onFileChange(e) {
      const selectedFile = e.target.files[0];
      console.log("Selected file:", selectedFile);
    
      // Assign file input element and validate
      this.attachment = e.target;
    
      if (!selectedFile) {
        console.error("No file selected");
        return;
      }
    
      // Validate file size and type
      if (selectedFile.size > 5000000) {
        this.$alertify.error("Please upload a document less than 6MB.");
        return;
      }
      if (!["image/jpeg", "image/png", "image/gif"].includes(selectedFile.type)) {
        this.$alertify.error("Invalid file type. Please upload a JPG, PNG, or GIF.");
        return;
      }
    
      this.FileSelected = selectedFile; // Valid file assigned
    },
    
    uploadFile() {
      this.isuploadLoading = true;
      if (!this.FileSelected) {
        this.$alertify.error("Please choose an image to upload.");
        return;
      }
    
      const fd = new FormData();
      fd.append("file", this.FileSelected);
      fd.append('shippingid', this.awbnumber);
      fd.append('primaryKey',123),
      fd.append('status', 0);
    
      axios
        .post(apiUrl.api_url_hubops + 'uploadImageFile', fd, {
          headers: {
            "Content-Type": "multipart/form-data",
            'authorization': 'authkey xB84JJ89Hd25',
          },
        })
        .then((response) => {
          this.isuploadLoading = false;
          console.log("Image uploaded successfully:", response.data);
    
          this.imagesarr.push({
            file: this.FileSelected.name,
            imgPath: response.data.data,
          });
    
          this.$alertify.success("Image uploaded successfully.");
          document.getElementById("fileInput").value = null; 
          this.FileSelected = null; 
        })
        .catch((error) => {
          console.error("Error uploading file:", error.response , error.message);
          this.$alertify.error("Failed to upload the image.");
        });
    },
    
    downloadImage(filePath, action = 'view') {
      const input = { key: filePath };
    
      axios.post(`${apiUrl.api_url_hubops}fetchImage`, input, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then((result) => {
        if (result.data.errorCode === 0) {
          const imageUrl = result.data.data;
    
          if (action === 'view') {
            window.open(imageUrl, '_blank'); // Open image in a new tab
            this.$alertify.success("Image viewed successfully.");
          } else if (action === 'download') {
            const a = document.createElement('a');
            a.href = imageUrl;
            a.download = filePath.split('/').pop(); // Extract filename from path
            a.click();
            this.$alertify.success("Image downloaded successfully.");
          }
        } else {
          this.$alertify.error(result.data.message);
        }
      })
      .catch((error) => {
        console.error(error);
        this.$alertify.error("An error occurred while fetching the image.");
      });
    },


    closeImage() {
      this.showModal = false;
    },

    deleteImage(i) {
      const fileName = (this.imagesarr[i] && this.imagesarr[i].file) || '';
      const currentdate = moment().format("DD_MM_YYYY");
      const input = { key: `STD/${this.awbnumber}/${currentdate}_${fileName}`, file: fileName };

      axios.post(`${ apiUrl.api_url_hubops}DeleteImageWrapper`, input, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then((result) => {
        if (result.data.errorCode === 0) {
          this.imagesarr.splice(i, 1);
          this.$alertify.success(result.data.message);
        } else {
          this.$alertify.error(result.data.message);
        }
      })
      .catch((error) => console.error(error));
    },

    updatedata() {
      if (!this.description) {
        this.$alertify.error("Please Fill Description.");
      } else if (!this.DEPSbagCondition) {
        this.$alertify.error("Please Select DEPS Bag Condition.");
      } else if (!this.STDreason) {
        this.$alertify.error("Please Select STD Reason.");
      } else if (this.imagesarr.length <= 2) {
        this.$alertify.error("Please Upload Three images");
      } else {
        const currentdate = moment().format("DD-MM-YYYY HH:mm:ss");
        const FinanceLoggeddate = moment().format("YYYY-MM-DD HH:mm:ss.SSS");
        this.isLoading = true;
        const input = {
          ShippingID: this.awbnumber,
          CurrentHubID: this.shipmenarr.CurrentHubID.toString(),
          ShipmentVerifiedAs: this.userid,
          Status: "1",
          STDbagcondition: this.DEPSbagCondition.label,
          StatusMarkedFrom: "Web",
          Comments: this.description,
          LastModifiedBy: this.userid,
          LastModifiedDate: currentdate,
          FinanceLoggeddate: FinanceLoggeddate,
          BucketTypeCode: 4,
          RequestFrom: "Finance",
          HubZoneID: this.HubZoneID,
          ActionStatusCode: ""
        };

        axios.post(`${ apiUrl.api_url_hubops}AddToInvestigation`, input, {
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'authkey xB84JJ89Hd25',
              },
        })
        .then((result) => {
          this.isLoading = false;
          if (result.data.ReturnCode === 100) {
            this.$alertify.success(result.data.ReturnMessage);
            this.resetForm();
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
        })
        .catch((error) => {
          console.error(error);
        });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/components/AddDamageByOperation/AddDamageByOperation.js